import { cn } from '@utils/cn';

import { Image } from '../../../../components/Image';

type InformationCardImage = {
  src: string;
  alt: string;
};

type InformationCardImages =
  | [InformationCardImage]
  | [InformationCardImage, InformationCardImage];

type InformationCardProps = {
  pill: {
    text: string;
    className: string;
    textClassName: string;
  };
  images?: InformationCardImages;
  text: string;
};

const ImageStack = ({ images }: { images: InformationCardImages }) => {
  const [frontImage, backImage] = images;

  return (
    <div className="isolate flex shrink-0 items-center">
      <div className="relative z-[2] -mr-6 flex size-[38px] items-center justify-center">
        <div className="-rotate-[4deg]">
          <div className="relative size-9 overflow-hidden rounded-md">
            <Image alt={frontImage.alt} src={frontImage.src} width={48} />
          </div>
        </div>
      </div>
      <div className="relative z-[1] flex size-[38px] items-center justify-center">
        <div className="rotate-[4deg]">
          <div className="relative size-9 overflow-hidden rounded-md">
            {backImage ? (
              <Image alt={backImage.alt} src={backImage.src} width={48} />
            ) : (
              <div className="absolute inset-0 bg-divider/20 backdrop-blur-[15px]" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const InformationCard = ({
  images,
  pill,
  text,
}: InformationCardProps) => {
  return (
    <div className="flex flex-row items-start gap-4 rounded-sm border border-dashed border-neutral-4/20 p-4">
      <div className="flex min-w-0 flex-1 flex-col items-start gap-3">
        <div className={cn('rounded-sm px-2 py-1', pill.className)}>
          <span className={cn('text-xs', pill.textClassName)}>{pill.text}</span>
        </div>
        <span className="text-sm-mobile">{text}</span>
      </div>
      {images && <ImageStack images={images} />}
    </div>
  );
};
